export { View as Offers } from './view'
